//import moment from 'moment';

export const log = (text, info) => {
    //console.log(`${moment().format('HH:mm:ss.SSS')} - ${text}`, info);
}

export const loggingMiddleware = store => next => action => {
    log(action.type, action);

    return next(action);
}